export default __webpack_public_path__ + "static/media/Group9267.dc51af22.svg";